function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import FlyInput from './fly-input';

/**
 * The FlySearch is a wrapper around the FlyInput component, and accepts all the same
 * arguments. It is intended to be used as an input that adds search functionality.
 *
 *
 * ```hbs
 * <FlySearch
 *  @value={{this.searchValue}}
 *  @onInput={{fn (mut this.searchValue)}}
 * />
 */

export default class FlySearch extends FlyInput {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderAsSearch", true);
  }
}